export { default } from './LeilaoDeVeiculosPassoAPasso';
